import {
  PACKAGE_PERIODS,
  PACKAGES_DESCRIPTION,
  PROMOTIONS,
  REALTOR_PACKAGE_ID_PREFIX,
  PACKAGE_PERIODS_TITLE
} from './packagesConfigs';

class Package {
  constructor({ index, id, properties, period }) {
    this.id = `${REALTOR_PACKAGE_ID_PREFIX}${id}`;
    this._period = period || PACKAGE_PERIODS.MONTH;
    this[PROMOTIONS.PROPERTIES] = properties;
    this.index = index;
  }

  get legacyPackageDescription() {
    const checked = Number(this.id.split('_').pop());
    const period = String(this._period.multiplier);

    return {
      checked,
      period
    };
  }

  get packageDescription() {
    const adsCount = this[PROMOTIONS.PROPERTIES];
    const packageData = PACKAGES_DESCRIPTION[adsCount] || {};
    return packageData[this._period.periodName] || {};
  }

  get currentPeriodValue() { return this._period.value; }

  get currentPeriodKey() { return this._period.label; }

  get packageNameKey() { return this.id.replace(REALTOR_PACKAGE_ID_PREFIX, ''); }

  get titlePrice() { return PACKAGE_PERIODS_TITLE[this.index]; }

  get oldPricePerMonth() {
      const packageData = this.packageDescription;
      const oldPricePerAd = packageData.oldPriceForAdPerMonth;

      return Math.round((oldPricePerAd * this[PROMOTIONS.PROPERTIES]));
  }

  get pricePerMonth() {
    const packageData = this.packageDescription;
    const pricePerAd = packageData.priceForAdPerMonth;

    return Math.round((pricePerAd * this[PROMOTIONS.PROPERTIES]));
  }

  get features() {
    const packageData = this.packageDescription;

    return packageData.features;
  }

  changePeriod = period => { this._period = period; };
}

export default Package;
